<script setup lang="ts">
import type { TabProps } from "./tab.types";
import { useTab } from "./useTab";

const props = defineProps<TabProps>();

const { classes } = useTab({ props });
</script>

<template>
  <div part="base" :class="classes" class="e-tab">
    <slot />
  </div>
</template>

<style>
:host {
  display: contents;
}
</style>
